// extracted by mini-css-extract-plugin
export var errorIcon = "_pv-1";
export var nameLogo = "_pv-0";